import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useCallback, useEffect, useState } from 'react';
import { getRovoTip, setRovoTip } from '@atlassian/search-common';
import { useUserContext } from '../../../common/user-context';
import { useProductContext } from '../../product-router';
export var useQuickFindRovoTip = function useQuickFindRovoTip() {
  var _useUserContext = useUserContext(),
    user = _useUserContext.user;
  var _useProductContext = useProductContext(),
    getActiveProduct = _useProductContext.getActiveProduct;
  var product = getActiveProduct();
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    showRovoTip = _useState2[0],
    setShowRovoTip = _useState2[1];
  useEffect(function () {
    if (!product) {
      return;
    }
    var rovoTipFromLocalStorage = getRovoTip(product.id, user === null || user === void 0 ? void 0 : user.id);
    setShowRovoTip(rovoTipFromLocalStorage);
  }, [user.id, product]);
  var dismissRovoTip = useCallback(function () {
    if (product !== null && product !== void 0 && product.id) {
      var rovoTipFromLocalStorage = setRovoTip(product.id, user === null || user === void 0 ? void 0 : user.id);
      setShowRovoTip(rovoTipFromLocalStorage);
    }
  }, [user.id, product]);
  return {
    showRovoTip: showRovoTip,
    dismissRovoTip: dismissRovoTip
  };
};